import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class MediaHorasExtrasMOTBStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findMediaHorasExtrasMOTB(filtro).then(response => {
            this.dados = response.data.map((produto) => ({
                nome: produto.produto,
                "Média (h)": produto.media
            }));

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
